import React, { useState } from 'react';
import { createMemoStyles, safeRest, defaultFonts, uniqueId } from '@wds/utils';
import { IconX, IconInfo, IconWarning, IconCheck, IconLock } from '@wds/icons';
import { Slide } from '@wds/motion';
import PropTypes from 'prop-types';
import { useTheme } from 'react-jss';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var useStyles$1 = createMemoStyles(function (_ref) {
  var spacing = _ref.spacing,
      type = _ref.type;
  return {
    wrenchCloseButton: function wrenchCloseButton(_ref2) {
      var component = _ref2.component;
      var componentSpecificStyles = {
        badge: {
          position: 'relative',
          top: 'none',
          right: 'none',
          padding: 0,
          marginLeft: spacing[3]
        },
        banner: {
          position: 'absolute',
          top: spacing[2],
          right: spacing[2],
          padding: 0
        },
        default: {
          position: 'absolute',
          right: spacing[1],
          top: spacing[1],
          padding: spacing[2]
        }
      };
      return _objectSpread(_objectSpread({}, componentSpecificStyles[component || 'default']), {}, {
        fontSize: type.fontSize.body,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        borderRadius: '0',
        textDecoration: 'none',
        background: 'transparent',
        border: 'none',
        '&:hover': {
          transition: 'none',
          textDecoration: 'none'
        },
        '&:active': {
          transition: 'none',
          outline: 'none'
        }
      });
    }
  };
});
var useStyles$2 = useStyles$1;
var _excluded = ["children", "component", "label", "onClick", "type", "variant"];

var CloseButton = function CloseButton(_ref) {
  _ref.children;
  var component = _ref.component,
      label = _ref.label,
      onClick = _ref.onClick;
  _ref.type;

  var variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();

  var _useStyles = useStyles$2({
    theme: theme,
    component: component
  }),
      wrenchCloseButton = _useStyles.wrenchCloseButton;

  return /*#__PURE__*/React.createElement("button", Object.assign({
    onClick: onClick,
    type: "button",
    className: wrenchCloseButton,
    "aria-label": label
  }, safeRest(rest)), /*#__PURE__*/React.createElement(IconX, {
    title: "close",
    color: variant
  }));
};

CloseButton.displayName = "CloseButton";
CloseButton.propTypes = {
  children: PropTypes.string,
  component: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.string,
  variant: PropTypes.oneOf(['dark', 'light'])
};
CloseButton.defaultProps = {
  children: 'CloseButton',
  component: undefined,
  type: undefined,
  variant: 'light'
};
var CloseButton$1 = CloseButton;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var FONT_WEIGHTS = ['light', 'regular', 'medium'];

var isColorShape = function isColorShape(c) {
  return _typeof(c) === 'object' && 'main' in c;
};

var getColor = function getColor(color) {
  return isColorShape(color) ? color.main : color;
};

process.env.NODE_ENV !== 'production' ? 'cdn.mtassets.net' : 'cdn.smassets.net';
var palette$1 = {
  transparent: 'transparent',
  primary: {
    main: '#00BF6F',
    contrast: '#FFFFFF'
  },
  secondary: {
    main: '#6B787F',
    contrast: '#FFFFFF'
  },
  success: {
    main: '#00BF6F',
    contrast: '#FFFFFF'
  },
  warning: {
    main: '#F05B24',
    contrast: '#FFFFFF'
  },
  error: {
    main: '#F05B24',
    contrast: '#FFFFFF'
  },
  info: {
    main: '#2DCCD3',
    contrast: '#333E48'
  },
  upgrade: {
    main: '#F9BE00',
    contrast: '#333E48'
  },
  muted: {
    main: '#D0D2D3',
    contrast: '#333E48'
  },
  link: {
    main: '#007FAA',
    contrast: '#FFFFFF'
  },
  text: {
    dark: '#333E48',
    light: '#FFFFFF',
    darkMuted: '#6B787F',
    lightMuted: '#D0D2D3',
    link: '#007FAA'
  },
  background: {
    main: '#F7F8FA',
    light: '#FFFFFF',
    dark: '#333E48',
    overlay: 'rgba(107, 120, 127, .86)',
    accent: '#EDEEEE'
  },
  border: {
    main: '#D0D2D3',
    active: '#404040',
    hover: '#757575',
    muted: '#EDEEEE'
  },
  data: {
    one: '#507CB6',
    two: '#00BF6F',
    three: '#6BC8CD',
    four: '#F9BE00',
    five: '#7D5E90',
    six: '#DB4D5C',
    seven: '#768086',
    eight: '#D25F90',
    nine: '#A38364',
    ten: '#FF8B4F'
  }
};
({
  main: [1, 'solid', getColor(palette$1.border.main)],
  hover: [1, 'solid', getColor(palette$1.border.hover)],
  active: [1, 'solid', getColor(palette$1.border.active)],
  muted: [1, 'solid', getColor(palette$1.border.muted)],
  dark: [1, 'solid', getColor(palette$1.background.dark)],
  light: [2, 'solid', getColor(palette$1.background.light)]
});
process.env.NODE_ENV !== 'production' ? 'cdn.mtassets.net' : 'cdn.smassets.net';
var palette = {
  transparent: 'transparent',
  primary: {
    main: '#008323',
    contrast: '#FFFFFF'
  },
  secondary: {
    main: '#757575',
    contrast: '#FFFFFF'
  },
  success: {
    main: '#008323',
    contrast: '#FFFFFF'
  },
  warning: {
    main: '#F7B500',
    contrast: '#404040'
  },
  error: {
    main: '#CC0000',
    contrast: '#FFFFFF'
  },
  info: {
    main: '#2cb2f1',
    contrast: '#000000'
  },
  upgrade: {
    main: '#ffe11b',
    contrast: '#404040'
  },
  muted: {
    main: '#d0d0d0',
    contrast: '#404040'
  },
  link: {
    main: '#0a7cc1',
    contrast: '#FFFFFF'
  },
  text: {
    dark: '#404040',
    light: '#FFFFFF',
    darkMuted: '#757575',
    lightMuted: '#efefef',
    link: '#0a7cc1'
  },
  background: {
    main: '#F5FAF6',
    light: '#ffffff',
    dark: '#404040',
    overlay: 'rgba(117, 117, 117, .86)',
    accent: '#efefef'
  },
  border: {
    main: '#d0d0d0',
    active: '#404040',
    hover: '#757575',
    muted: '#EDEEEE'
  },
  data: {
    one: '#507CB6',
    two: '#008323',
    three: '#6BC8CD',
    four: '#F9BE00',
    five: '#7D5E90',
    six: '#DB4D5C',
    seven: '#768086',
    eight: '#D25F90',
    nine: '#A38364',
    ten: '#FF8B4F'
  }
};
({
  main: [1, 'solid', getColor(palette.border.main)],
  hover: [1, 'solid', getColor(palette.border.hover)],
  active: [1, 'solid', getColor(palette.border.active)],
  muted: [1, 'solid', getColor(palette.border.muted)],
  dark: [1, 'solid', getColor(palette.background.dark)],
  light: [2, 'solid', getColor(palette.background.light)]
});
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

createMemoStyles(function (_a) {
  var _b = _a.type,
      assets = _b.assets,
      fontFamily = _b.fontFamily,
      fontWeight = _b.fontWeight,
      fontSize = _b.fontSize;
  var fontPath = "".concat(assets.base).concat(assets.path);
  var fontFaces = FONT_WEIGHTS.map(function (name) {
    // we need this because the font file names are all National2-<Weight>.2.ext
    var upperCaseName = "".concat(name[0].toUpperCase()).concat(name.slice(1));
    var weight = fontWeight[name];
    return {
      fontFamily: assets.name,
      fontWeight: weight,
      fontDisplay: 'swap',
      src: "url(".concat(fontPath, "-").concat(upperCaseName, ".").concat(assets.version, ".woff2) format('woff2')"),
      fallbacks: [{
        src: "url(".concat(fontPath, "-").concat(upperCaseName, ".").concat(assets.version, ".woff) format('woff')")
      }, {
        src: "url(".concat(fontPath, "-").concat(upperCaseName, ".").concat(assets.version, ".eot#iefix) format('embedded-opentype')")
      }]
    };
  });
  return {
    '@font-face': fontFaces,
    '@global': {
      "[class*='wrench'], [class*='wrench']::before, [class*='wrench']::after": {
        fontFamily: fontFamily.base,
        '-webkit-font-smoothing': 'antialiased',
        fontSize: fontSize.body,
        boxSizing: 'border-box',
        padding: 0,
        margin: 0,
        listStyle: 'none'
      }
    }
  };
});
var useStyles = createMemoStyles(function (theme) {
  var palette = theme.palette,
      spacing = theme.spacing,
      type = theme.type,
      radius = theme.radius;
  var banner = {
    borderRadius: radius.small,
    bgColor: palette.background.light,
    typeColor: palette.background.dark,
    markWidth: 8,
    borderSize: 1
  };
  return {
    wrenchBanner: function (_a) {
      var color = _a.color;
      var _color = color;
      return __assign(__assign({}, defaultFonts(theme)), {
        position: 'relative',
        display: 'flex',
        alignItems: 'flex-start',
        fontWeight: type.fontWeight.regular,
        color: banner.typeColor,
        border: [banner.borderSize, 'solid', getColor(palette[_color])],
        borderLeftWidth: banner.markWidth,
        borderRadius: banner.borderRadius,
        background: banner.bgColor,
        margin: '0',
        padding: [spacing[5], spacing[6], spacing[5], spacing[5]]
      });
    },
    wrenchBannerBody: function (_a) {
      var showIcon = _a.showIcon;
      return {
        flexGrow: 1,
        paddingLeft: showIcon ? spacing[5] : 0
      };
    },
    wrenchBannerActions: function () {
      return {
        padding: [spacing[4], 0, 0]
      };
    },
    wrenchBannerIcon: function () {
      return {
        display: 'flex',
        marginTop: 2
      };
    }
  };
});
Object.freeze(['success', 'info', 'upgrade', 'warning', 'error']);

var Banner = function (_a) {
  var children = _a.children,
      _b = _a.color,
      color = _b === void 0 ? 'info' : _b,
      _c = _a.showIcon,
      showIcon = _c === void 0 ? false : _c,
      _d = _a.dismissible,
      dismissible = _d === void 0 ? false : _d,
      _e = _a.show,
      show = _e === void 0 ? true : _e,
      onClose = _a.onClose,
      _f = _a.closeButtonLabel,
      closeButtonLabel = _f === void 0 ? 'Close Banner' : _f,
      actions = _a.actions,
      rest = __rest(_a, ["children", "color", "showIcon", "dismissible", "show", "onClose", "closeButtonLabel", "actions"]);

  var _g = useState(false),
      close = _g[0],
      setClose = _g[1];

  var role = color === 'error' || color === 'warning' ? 'alert' : 'status';

  var _h = useStyles({
    color: color,
    showIcon: showIcon
  }),
      wrenchBannerActions = _h.wrenchBannerActions,
      wrenchBanner = _h.wrenchBanner,
      wrenchBannerBody = _h.wrenchBannerBody,
      wrenchBannerIcon = _h.wrenchBannerIcon;

  var bodyId = uniqueId('banner');
  var BannerIcon = {
    info: IconInfo,
    warning: IconWarning,
    error: IconWarning,
    success: IconCheck,
    upgrade: IconLock
  }[color];

  var handleClick = function () {
    setClose(true);

    if (onClose) {
      onClose();
    }
  };

  var Actions = function () {
    return React.createElement("div", {
      className: wrenchBannerActions || ''
    }, actions);
  };

  return React.createElement(Slide, {
    in: !close && show,
    direction: "down",
    distance: "far"
  }, React.createElement("div", null, React.createElement("div", __assign({
    className: wrenchBanner,
    role: role,
    tabIndex: 0,
    "aria-describedby": bodyId
  }, safeRest(rest)), dismissible && React.createElement(CloseButton$1, {
    onClick: handleClick,
    component: "banner",
    label: closeButtonLabel,
    variant: "dark"
  }), showIcon && React.createElement("div", {
    className: wrenchBannerIcon
  }, React.createElement(BannerIcon, {
    color: color,
    title: "".concat(color, " icon.")
  })), React.createElement("div", {
    className: wrenchBannerBody,
    id: bodyId
  }, children, actions && React.createElement(Actions, null)))));
};

var BANNER_COLORS = ['success', 'warning', 'error', 'info', 'upgrade'];
export { BANNER_COLORS, Banner };